import instance from '../instance';

const getStaticElement = (elementId) => instance.driver.referenceMap.getReferenceById(elementId);

export default getStaticElement;
